window.direct = {};

import "../../node_modules/bootstrap/dist/js/bootstrap.bundle";

import "./modules/apireference";
import "./modules/scroll";
